var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dropdown" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "click-outside",
              rawName: "v-click-outside",
              value: _vm.onBlur,
              expression: "onBlur"
            }
          ],
          on: { click: _vm.toggleDropdown }
        },
        [_vm._t("trigger", null, { isOpen: _vm.isDropped })],
        2
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide-fade" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isDropped,
                expression: "isDropped"
              }
            ],
            staticClass: "dropdown__content"
          },
          [
            _vm.data
              ? _c(
                  "ul",
                  _vm._l(_vm.data.data, function(item, index) {
                    return _c("DropdownItem", {
                      key: index,
                      attrs: { item: item, tag: "li" }
                    })
                  }),
                  1
                )
              : _vm._t("body")
          ],
          2
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }